import { useState, type ReactNode } from 'react';
import { Panel } from '../layout/Panel';
import './charts.css';

export interface ChartSwitcherProps {
  apartPanels: { title: string; chart: ReactNode; legend: ReactNode }[];
  combinedPanel: { title: string; chart: ReactNode; legend: ReactNode };
}

export function ChartSwitcher({ apartPanels, combinedPanel }: ChartSwitcherProps) {
  const [view, setView] = useState<'apart' | 'combine'>('apart');

  const toolbar = (
    <div className="toolbar-segment">
      <button
        className={`toolbar-btn ${view === 'apart' ? 'active' : ''}`}
        onClick={() => setView('apart')}
      >Apart</button>
      <button
        className={`toolbar-btn ${view === 'combine' ? 'active' : ''}`}
        onClick={() => setView('combine')}
      >Combinatie</button>
    </div>
  );

  if (view === 'apart') {
    return (<>
      {apartPanels.map((p, i) => (
        <Panel key={i} className="panel-chart">
          <div className="chart-toolbar">
            <h3>{p.title}</h3>
            <div className="toolbar-right">{i === 0 ? toolbar : null}</div>
          </div>
          {p.chart}
          <div className="legend-bar">{p.legend}</div>
        </Panel>
      ))}
    </>);
  }

  return (
    <Panel className="panel-chart combine">
      <div className="chart-toolbar">
        <h3>{combinedPanel.title}</h3>
        <div className="toolbar-right">{toolbar}</div>
      </div>
      {combinedPanel.chart}
      <div className="legend-bar">{combinedPanel.legend}</div>
    </Panel>
  );
}
